// Core packages
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
// Third party packages
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
// Custom packages
import { ConfigService } from "./config.service";
import { EnvironmentService } from "./environment.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./environment.service";
import * as i3 from "ngx-toastr";
import * as i4 from "@ngx-translate/core";
import * as i5 from "@angular/router";
import * as i6 from "ngx-cookie-service";
import * as i7 from "./config.service";
var ApiService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ApiService(http, environmentService, toastrService, translateService, router, cookieService, configService) {
        this.http = http;
        this.environmentService = environmentService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.router = router;
        this.cookieService = cookieService;
        this.configService = configService;
        this.endpoint = this.environmentService.getApiUrl();
        this.httpOptions = {};
    }
    /**
     * Get current values of session stored in cookie
     *
     * @since 1.0.0
     *
     * @returns object
     */
    ApiService.prototype.getCookiesItems = function () {
        var sid = this.cookieService.get("s.id");
        var sexpiresAt = this.cookieService.get("s.expiresAt");
        return { sid: sid, sexpiresAt: sexpiresAt };
    };
    /**
     * This method is a wrapper to call back-end APIs
     *
     * @since 1.0.0
     *
     * @param method HTTP Verbs to use. Can be 'GET', 'POST', 'PUT', 'DELETE'
     * @param path The endpoint relative path
     * @param [params] Optional api call params that needs to be attached to the call
     * @param extraOptions optiona extra option attached to the call
     * @param autoRefresh
     * @param supplier Route API to new Suppliers BE
     * @param version API version override (e.g. 'v2'). Defaults to environment.apiVersion
     * @returns Observable<any>
     */
    ApiService.prototype.apiCall = function (method, path, params, extraOptions, autoRefresh, supplier, version) {
        var _this = this;
        if (typeof supplier !== "undefined" && supplier) {
            this.endpoint = this.environmentService.getSuppliersApiUrl();
        }
        else {
            this.endpoint = this.environmentService.getApiUrl(version);
        }
        var autoRefreshToken = typeof autoRefresh === "undefined" ? true : autoRefresh;
        if (typeof method === "undefined") {
            return of("Missing method");
        }
        var functionName = "apiCall" + method.toUpperCase();
        var functionToCall = this[functionName];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var thePath = path.endsWith("/") ? path.substring(-1) : path;
        // Get session data
        // If user is already logged in, just add his token
        // to the request header
        var sessData = this.getCookiesItems();
        var sid = sessData.sid;
        var sexpiresAt = sessData.sexpiresAt;
        // Init headers
        var acceptLang = this.cookieService.get("lang") || this.configService.defaultLang;
        var headers = new HttpHeaders().set("Accept-Language", acceptLang);
        if (extraOptions && extraOptions.contentType) {
            if (extraOptions.contentType !== "auto") {
                headers = headers.append("Content-Type", extraOptions.contentType);
            }
            else {
                // headers = headers.set('Content-Type', '');
                headers = headers.delete("Content-Type");
            }
            delete extraOptions.contentType; // Remove extra option after this line
        }
        else {
            headers = headers.append("Content-Type", "application/json");
        }
        if (sid && moment.now() < parseInt(sexpiresAt, 10)) {
            headers = headers.append("Authorization", "Bearer " + sid);
        }
        // Opt-in: unsubscribing aborts the request. Off by default, since callers that unsubscribe on
        // destroy rely on their requests reaching the back-end anyway (a save before leaving a page). Not
        // carried by the retry after a 401 refresh: callers that need it pass autoRefresh = false.
        var abortOnUnsubscribe = !!(extraOptions && extraOptions.abortOnUnsubscribe === true);
        if (extraOptions && extraOptions.hasOwnProperty("abortOnUnsubscribe")) {
            delete extraOptions.abortOnUnsubscribe;
        }
        if (extraOptions && extraOptions["X-Refresh-Token"]) {
            headers = headers.append("X-Refresh-Token", "Bearer " + extraOptions["X-Refresh-Token"]);
        }
        var requestedRole = this.cookieService.get("requestedRole");
        if (requestedRole) {
            headers = headers.append("X-Requested-Role", requestedRole);
        }
        var requestedCompany = this.cookieService.get("requestedCompany");
        if (requestedCompany) {
            headers = headers.append("X-Requested-Company", requestedCompany);
        }
        // Set httpOptions
        this.httpOptions = {
            headers: headers,
        };
        if (typeof functionToCall === "function") {
            return new Observable(function (obs) {
                var theParams = params || {};
                // Remove property with empty, undefined or null value
                // from params since they are not useful and - also -
                // since back-end could not accept undefined|null values
                // @see https://stackoverflow.com/questions/25421233/javascript-removing-undefined-fields-from-an-object
                // Object.keys(theParams).forEach(key => !theParams[key] && delete theParams[key]);
                Object.keys(theParams).forEach(function (key) {
                    return (theParams[key] === "undefined" ||
                        theParams[key] === undefined ||
                        theParams[key] === null) &&
                        delete theParams[key];
                });
                // Remove 'requiredFields' from params since it's front-end-only data
                if (theParams.hasOwnProperty("requiredFields")) {
                    delete theParams.requiredFields;
                }
                var obs1 = self[functionName](thePath, theParams, extraOptions);
                var requestSubscription = obs1.subscribe(function (res) {
                    return obs.next(res);
                }, function (err) {
                    var refreshTokenExp = +_this.cookieService.get("s.refreshTokenExpiresAt");
                    // If error status is 401 means that we are not logged in
                    // But before logging out, let's check if a not-expired refresh-token
                    // is saved in our cookies.
                    // If so, let's try to re-authenticate with that refreshToken
                    if (autoRefreshToken &&
                        err.status === 401 &&
                        _this.cookieService.get("s.refreshToken") &&
                        !(moment.unix(moment.now()) > moment.unix(refreshTokenExp))) {
                        var refreshToken = _this.cookieService.get("s.refreshToken");
                        var headers2 = new HttpHeaders().set("Accept-Language", _this.cookieService.get("lang"));
                        headers2 = headers2.append("Content-Type", "application/json");
                        headers2 = headers2.append("X-Refresh-Token", "Bearer " + refreshToken);
                        return _this.http
                            .post(_this.environmentService.getApiUrl("v2") +
                            "/auth/refreshtoken", {}, { headers: headers2 })
                            .subscribe(function (result) {
                            _this.setSession(result.data || result);
                            return _this.apiCall(method, path, params, extraOptions, false, supplier, version).subscribe(function (res2) {
                                obs.next(res2);
                            }, function (err2) {
                                obs.error(err2);
                            }, function () {
                                return obs.complete();
                            });
                        }, function () {
                            obs.error(err);
                        });
                        // return obs.error(err);
                    }
                    else {
                        return obs.error(err);
                    }
                }, function () {
                    return obs.complete();
                });
                // Teardown: only an opt-in call aborts its request when unsubscribed (@see abortOnUnsubscribe)
                return function () {
                    if (abortOnUnsubscribe) {
                        requestSubscription.unsubscribe();
                    }
                };
            });
        }
        else {
            console.warn("return EMPTY");
            return EMPTY;
        }
    };
    /**
     * Perform a POST API call with given path and
     * given params
     *
     * @since 1.0.0
     */
    ApiService.prototype.apiCallPOST = function (path, params, extraOptions) {
        var options = this.httpOptions;
        if (typeof extraOptions !== "undefined") {
            Object.assign(options, extraOptions);
        }
        return this.http
            .post(this.endpoint + "/" + path, params, options) // JSON.stringify(params)
            .pipe(catchError(this.handleError));
    };
    /**
     * Perform a PUT API call with given path and
     * given params
     *
     * @since 1.0.0
     */
    ApiService.prototype.apiCallPUT = function (path, params, extraOptions) {
        var options = this.httpOptions;
        if (typeof extraOptions !== "undefined") {
            Object.assign(options, extraOptions);
        }
        return this.http
            .put(this.endpoint + "/" + path, params, options)
            .pipe(catchError(this.handleError));
    };
    /**
     * Perform a PATCH API call with given path and
     * given params
     *
     * @since 1.0.0
     */
    ApiService.prototype.apiCallPATCH = function (path, params, extraOptions) {
        var options = this.httpOptions;
        if (typeof extraOptions !== "undefined") {
            Object.assign(options, extraOptions);
        }
        return this.http
            .patch(this.endpoint + "/" + path, params, options)
            .pipe(catchError(this.handleError));
    };
    /**
     * Perform a GET API call with given path and
     * given params
     *
     * @since 1.0.0
     */
    ApiService.prototype.apiCallGET = function (path, params, extraOptions) {
        var options = this.httpOptions;
        if (typeof params !== "undefined") {
            options.params = params;
        }
        if (typeof extraOptions !== "undefined") {
            Object.assign(options, extraOptions);
        }
        return this.http
            .get(this.endpoint + "/" + path, options)
            .pipe(catchError(this.handleError));
    };
    /**
     * Perform a DELETE API call with given path and
     * given params
     *
     * @since 1.0.0
     */
    ApiService.prototype.apiCallDELETE = function (path, params, extraOptions) {
        var options = this.httpOptions;
        if (typeof params !== "undefined") {
            options.params = params;
        }
        if (typeof extraOptions !== "undefined") {
            Object.assign(options, extraOptions);
        }
        return this.http
            .delete(this.endpoint + "/" + path, options)
            .pipe(catchError(this.handleError));
    };
    /**
     * Since we are not using a type checker,
     * the response should be extracted.
     *
     * @since 1.0.0
     */
    ApiService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    /**
     * Handle http errors
     *
     * @since 1.0.0
     */
    ApiService.prototype.handleError = function (error) {
        // const message = error.error.message;
        // if (typeof context.toastrService !== 'undefined') {
        //   context.toastrService.error(message);
        // }
        if (error.status === 0) {
            return of(new Error("Unexpected error. Please reload the page and try again"));
        }
        return throwError(error);
    };
    /**
     * Set given login result data as current session
     *
     * @since 1.0.0
     *
     * @param data Session data coming from back-end
     */
    ApiService.prototype.setSession = function (data) {
        var expiresAt = moment().add(data.expiresIn, "second");
        this.cookieService.set("s.id", data.token, null, "/", this.environmentService.getFrontEndHost(), true);
        this.cookieService.set("s.expiresAt", JSON.stringify(expiresAt.valueOf()), null, "/", this.environmentService.getFrontEndHost(), true);
        if (data.user && data.user.userRoles && data.user.userRoles[0]) {
            this.cookieService.set("requestedRole", data.user.userRoles[0].role._id, // data.user.roles[0]._id,
            null, "/", this.environmentService.getFrontEndHost(), true);
            if (data.user.userRoles[0].company) {
                this.cookieService.set("requestedCompany", data.user.userRoles[0].company._id.toString(), // data.user.roles[0]._id,
                null, "/", this.environmentService.getFrontEndHost(), true);
            }
        }
        if (data.refreshToken) {
            this.cookieService.set("s.refreshToken", data.refreshToken, null, "/", this.environmentService.getFrontEndHost(), true);
        }
        if (data.refreshExpiresIn) {
            var refreshExpiresAt = moment().add(data.refreshExpiresIn, "second");
            this.cookieService.set("s.refreshTokenExpiresAt", JSON.stringify(refreshExpiresAt.valueOf()), null, "/", this.environmentService.getFrontEndHost(), true);
        }
    };
    ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvironmentService), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.TranslateService), i0.ɵɵinject(i5.Router), i0.ɵɵinject(i6.CookieService), i0.ɵɵinject(i7.ConfigService)); }, token: ApiService, providedIn: "root" });
    return ApiService;
}());
export { ApiService };
